const wording = {
  }

  export default wording